import { StaffExpenseCategoryResponse } from "lib-klab-sdks";
import { ExpenseCategory } from "../../../domain/models/accounting/expense-category.model";

export function mapExpenseCategory(source: StaffExpenseCategoryResponse): ExpenseCategory {
  return {
    id: source.expenseCategoryId,
    companyId: source.companyId,
    code: source.code,
    name: source.name,
    statusId: source.statusId,
  };
}
